import * as React from "react";
import { calculateAgeForHost } from "../Helper/AgeCalculator";
var Fragment = React.Fragment;
export default function HostName(host) {
  return /*#__PURE__*/React.createElement(Fragment, null, host.name, " (", calculateAgeForHost(host), ")");
}